import { onCLS, onINP, onLCP, onTTFB, onFCP, type Metric } from "web-vitals";

function sendToAnalytics(metric: Metric) {
  // Send to Google Analytics 4 if gtag is available.
  // Uses GA4's recommended event shape so metrics appear as custom metrics
  // and the value is GA4-friendly (CLS is multiplied by 1000).
  if (typeof window !== "undefined" && "gtag" in window) {
    (window as any).gtag("event", metric.name, {
      value: Math.round(metric.name === "CLS" ? metric.value * 1000 : metric.value),
      metric_id: metric.id,
      metric_value: metric.value,
      metric_delta: metric.delta,
      metric_rating: metric.rating,
      event_category: "Web Vitals",
      event_label: metric.id,
      non_interaction: true,
      transport_type: "beacon",
    });
  }
}

function logMetric(metric: Metric) {
  const isGood =
    (metric.name === "CLS" && metric.value <= 0.1) ||
    (metric.name === "INP" && metric.value <= 200) ||
    (metric.name === "LCP" && metric.value <= 2500) ||
    (metric.name === "FCP" && metric.value <= 1800) ||
    (metric.name === "TTFB" && metric.value <= 800);

  const ratingColor =
    metric.rating === "good"
      ? "#22c55e"
      : metric.rating === "needs-improvement"
        ? "#f59e0b"
        : "#ef4444";

  console.log(
    `%c[Web Vitals] ${metric.name}`,
    `color: ${ratingColor}; font-weight: bold;`,
    {
      value:
        metric.name === "CLS"
          ? metric.value.toFixed(3)
          : `${Math.round(metric.value)} ms`,
      rating: metric.rating,
      id: metric.id,
      entries: metric.entries.length,
      ...(metric.navigationType && { navigationType: metric.navigationType }),
    }
  );

  sendToAnalytics(metric);
}

export function initWebVitals() {
  onCLS(logMetric);
  onINP(logMetric);
  onLCP(logMetric);
  onFCP(logMetric);
  onTTFB(logMetric);
}
